// extracted by mini-css-extract-plugin
export var desc = "Size-module--desc--4f94f";
export var shoe = "Size-module--shoe--92442";
export var size = "Size-module--size--6f783";
export var table = "Size-module--table--8d7cd";
export var title = "Size-module--title--c28aa";